/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerFileStorageDestinationComponent', [
    'DesignerBaseSourceAndDestinationComponent',

    function (DesignerBaseSourceAndDestinationComponent) {
      function DesignerFileStorageDestinationComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        // this.cloud_storage_connection_id = null;
        // this.bucket = null;
        // this.path = null;
        // this.destination_type = null;
        // this.compression_type = null;
        // this.delete_destination_path = null;
        // this.enforce_single_file = null;
      }

      DesignerFileStorageDestinationComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerFileStorageDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.defaults(this, this.defaults);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          bucket: this.bucket,
          path: this.path,
          file_names: this.file_names,
          prefix: this.prefix,
          suffix: this.suffix,
          destination_type: this.destination_type,
          compression_type: this.compression_type,
          enforce_single_file: this.enforce_single_file,
          operation_type: this.operation_type,
          char_encoding: this.char_encoding || 'utf-8',
          delete_destination_path: this.delete_destination_path,
          destination_exists_action: this.destination_exists_action,
          connection: this.connection.getData(),
        });

        return data;
      };

      DesignerFileStorageDestinationComponent.prototype.setFormData = function (data) {
        if (
          data.connection.type !== 's3' &&
          data.connection.type !== 'gs' &&
          data.connection.type !== 'azureblobstorage'
        ) {
          data.bucket = '';
        }

        if (
          data.destination_type &&
          data.destination_type.csv_destination_type &&
          data.destination_type.csv_destination_type.text_qualifier === 'none'
        ) {
          data.destination_type.csv_destination_type.text_qualifier = '';
        }

        if (data.destination_type.parquet_destination_type) {
          data.compression_type = 'none';
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerFileStorageDestinationComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.bucket = data.bucket;
        this.path = data.path;
        this.file_names = data.file_names;
        this.prefix = data.prefix;
        this.suffix = data.suffix;
        this.destination_type = data.destination_type;
        this.compression_type = data.compression_type;
        this.record_settings = data.record_settings;
        this.enforce_single_file = data.enforce_single_file;
        this.delete_destination_path = data.delete_destination_path;
        this.destination_exists_action = data.destination_exists_action;
        this.operation_type = data.operation_type;
        this.char_encoding = data.char_encoding || 'utf-8';

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerFileStorageDestinationComponent.prototype.setParentSchema = function () {
        const _this = this;
        const parentSchema = this.getParentSchema();
        const parentSchemaData = parentSchema.getData();

        this.schema.id = this.id;
        this.schema.name = this.name;

        this.schema.removeAllFields();

        _.each(parentSchemaData.fields, function (field) {
          _this.schema.addField({
            name: field.name,
            alias: field.name,
            data_type: 'string',
          });
        });
      };

      return DesignerFileStorageDestinationComponent;
    },
  ]);
})(window.angular);
